module.exports = __webpack_public_path__ + "img/offers3.7318f695.jpg";